import ParentWrapper from './parentWrapper';

const Test = {
  ParentWrapper,
};

export default Test;
